module.exports = __webpack_public_path__ + "static/media/shopify-success.4970e7a6.svg";